module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.detailInfo.id) ? _c('div', {
    staticClass: "question-wrapper"
  }, [_c('detail-title', {
    attrs: {
      "title": _vm.isAnswer ? '问答专区' : '文章专区',
      "isShowTitle": _vm.isShowTitle,
      "detailInfo": _vm.detailInfo,
      "isEditor": _vm.isEditor,
      "isAnswer": _vm.isAnswer
    },
    on: {
      "toPersonal": _vm.toPersonal,
      "editQuestion": _vm.editQuestion,
      "deletePop": _vm.deletePop
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.initShow),
      expression: "initShow"
    }],
    staticClass: "left-content"
  }, [_c('p', {
    staticClass: "comment-content",
    on: {
      "click": _vm.scrollIntoComment
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "answered-total answers-num"
  }, [_vm._v(_vm._s(_vm.detailInfo.no_of_comment || 0))])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "popper-class": "icon-tip",
      "content": _vm.detailInfo.is_followed ? '取消关注' : '关注',
      "placement": "top"
    }
  }, [(_vm.isAnswer) ? _c('p', {
    class: ['follow-content', {
      'is-follow': _vm.detailInfo.is_followed
    }],
    on: {
      "click": _vm.focusToggle
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "focus-total answers-num"
  }, [_vm._v(_vm._s(_vm.detailInfo.no_of_followed || 0))])]) : _vm._e()]), _vm._v(" "), (!_vm.isAnswer) ? [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "popper-class": "icon-tip",
      "content": _vm.detailInfo.is_vote_up ? '取消点赞' : '点赞',
      "placement": "top"
    }
  }, [_c('p', {
    class: ['great-content', {
      'is-great': _vm.detailInfo.is_vote_up
    }],
    on: {
      "click": function($event) {
        return _vm.onVoteToggle(_vm.detailInfo)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "focus-total answers-num"
  }, [_vm._v(_vm._s(_vm.detailInfo.no_of_vote_up || 0))])])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "popper-class": "icon-tip",
      "content": _vm.detailInfo.is_liked ? '取消收藏' : '收藏',
      "placement": "top"
    }
  }, [_c('p', {
    class: ['favorite-content', {
      'is-favorite': _vm.detailInfo.is_liked
    }],
    on: {
      "click": function($event) {
        return _vm.favoriteToggle(_vm.detailInfo)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "focus-total answers-num"
  }, [_vm._v(_vm._s(_vm.detailInfo.no_of_likes || 0))])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "share"
  }, [_c('span', [_vm._v("分享")]), _vm._v(" "), _c('div', {
    staticClass: "social-share",
    attrs: {
      "data-initialized": "true"
    }
  }, [_c('a', {
    staticClass: "social-share-icon icon-wechat",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "popper-class": "icon-tip",
      "content": "分享至QQ",
      "placement": "top"
    }
  }, [_c('a', {
    staticClass: "social-share-icon icon-qq",
    attrs: {
      "href": "#"
    }
  })]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "popper-class": "icon-tip",
      "content": "分享至微博",
      "placement": "top"
    }
  }, [_c('a', {
    staticClass: "social-share-icon icon-weibo",
    attrs: {
      "href": "#"
    }
  })])], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "popper-class": "icon-tip",
      "content": "复制链接",
      "placement": "top"
    }
  }, [_c('span', {
    staticClass: "icon icon-copy",
    on: {
      "click": _vm.onCopyUrl
    }
  })])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "center-content"
  }, [_c('div', {
    staticClass: "center-top-content"
  }, [_c('div', {
    staticClass: "basic-info"
  }, [_c('div', {
    staticClass: "head-title"
  }, [(_vm.isShowTag) ? _c('div', {
    class: [_vm.detailInfo.is_reprint ? 'reprint' : 'original']
  }, [_vm._v(_vm._s(_vm.detailInfo.is_reprint ? '转载' : '原创'))]) : _vm._e(), _vm._v(" "), (_vm.detailInfo.is_top) ? _c('img', {
    attrs: {
      "src": require("../../images/community/top.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.detailInfo.title))]), _vm._v(" "), (_vm.detailInfo.comment_is_accept_by_topic) ? _c('span', {
    staticClass: "solved"
  }, [_vm._v("已解决")]) : _vm._e()]), _vm._v(" "), (_vm.detailInfo.created_by) ? _c('div', {
    staticClass: "questioner-info"
  }, [_c('el-popover', {
    attrs: {
      "popper-class": "user-card",
      "placement": "top",
      "open-delay": 500,
      "width": "400",
      "trigger": "hover"
    },
    on: {
      "show": function($event) {
        _vm.$refs['card' + _vm.detailInfo.created_by.id].getUserInfo()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0, padding: 0"
    }
  }, [_c('user-card', {
    ref: ("card" + (_vm.detailInfo.created_by.id)),
    attrs: {
      "user-id": _vm.detailInfo.created_by.id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-avatar",
    attrs: {
      "slot": "reference"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    },
    slot: "reference"
  }, [_c('span', {
    staticClass: "user-portrait",
    on: {
      "click": _vm.toPersonal
    }
  }, [(_vm.detailInfo.created_by.user_logo.substr(0, 1) == '?') ? _c('img', {
    staticClass: "identity-icon",
    attrs: {
      "width": "26",
      "height": "26",
      "src": require("../../images/personal_center/avatar_default.png")
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.detailInfo.created_by.user_logo,
      "alt": "",
      "width": "26",
      "height": "26"
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "questioner-name"
  }, [_vm._v(_vm._s(_vm.detailInfo.created_by.nick_name))]), _vm._v(" "), (_vm.detailInfo.created_by.is_official) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "蓝鲸智云官方",
      "placement": "right"
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-lanjingguanfang"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.detailInfo.created_by.is_vip) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "核心用户",
      "placement": "right"
    }
  }, [_c('span', {
    staticClass: "icon-vipuser"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "question-time"
  }, [_vm._v("于" + _vm._s(_vm.detailInfo.created_on))]), _vm._v(" "), _c('span', [_vm._v("发布")]), _vm._v(" "), _c('p', {
    staticClass: "question-view"
  }, [_c('i', {
    staticClass: "view-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.detailInfo.no_of_views) + "阅览")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "marginLeft": "15px"
    }
  }, [_vm._v("更新于 " + _vm._s(_vm.detailInfo.updated_on))]), _vm._v(" "), (_vm.isEditor) ? _c('ul', {
    staticClass: "editor-list"
  }, [_c('li', {
    staticClass: "editor-btn",
    on: {
      "click": _vm.editQuestion
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('li', {
    staticClass: "delete-btn",
    on: {
      "click": _vm.deletePop
    }
  }, [_vm._v("删除")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, _vm._l((_vm.detailInfo.tags), function(item, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t\t\t")])
  }), 0)]), _vm._v(" "), (_vm.detailInfo.description !== '<p><br></p>' && _vm.detailInfo.description !== '') ? _c('div', {
    staticClass: "question-content markdown-body"
  }, [_c('p', {
    ref: "descHook",
    staticClass: "question-desc img-hook",
    domProps: {
      "innerHTML": _vm._s(_vm.filterXSS(_vm.afterhtmlData))
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.getImgUrl($event)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('comment', {
    ref: "comment",
    attrs: {
      "isLogin": _vm.isLogin,
      "isAnswer": _vm.isAnswer,
      "curUserInfo": _vm.userInfo,
      "detailInfo": _vm.detailInfo
    },
    on: {
      "onSwitchAccept": _vm.onSwitchAccept,
      "favoriteToggle": _vm.favoriteToggle,
      "focusToggle": _vm.focusToggle
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.initShow),
      expression: "initShow"
    }],
    staticClass: "right-content"
  }, [_c('communityRightContent', {
    ref: "rightChild",
    attrs: {
      "tags": _vm.detailInfo.tags,
      "isAnswer": _vm.isAnswer
    }
  })], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  }), _vm._v(" "), _c('goback')], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-65b56f6c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/community/deatils.vue
// module id = cC7I
// module chunks = 12